import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import PeriodoPresupuestarioRegiones from './PeriodoPresupuestarioRegiones.jsx'
import PeriodoPresupuestarioRegionDetalle from './PeriodoPresupuestarioRegionDetalle.jsx'
import PeriodoPresupuestarioSubregiones from './PeriodoPresupuestarioSubregiones.jsx'
import PeriodoPresupuestarioSubregionDetalle from './PeriodoPresupuestarioSubregionDetalle.jsx'
import PeriodoPresupuestarioBases from './PeriodoPresupuestarioBases.jsx'
import PeriodoPresupuestarioBaseDetalle from './PeriodoPresupuestarioBaseDetalle.jsx'

class PeriodoPresupuestario extends Component {
    render() {
        return (
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-md-6 col-12 mb-2">
                        <h3 className="content-header-title">
                            <FormattedMessage id="periodoPresupuestario.titulo" defaultMessage="Periodo Presupuestario" />
                        </h3>
                    </div>
                </div>
                <div className="content-body">
                    <Switch>
                        <Route exact path={this.props.match.url + '/regiones'} component={PeriodoPresupuestarioRegiones} />
                        <Route exact path={this.props.match.url + '/regiones/:id/edit'} render={(props) => <PeriodoPresupuestarioRegionDetalle {...props} action="EDIT" />} />
                        <Route path={this.props.match.url + '/regiones/:id'} render={(props) => <PeriodoPresupuestarioRegionDetalle {...props} action="VIEW" />} />
                        <Route exact path={this.props.match.url + '/subregiones'} component={PeriodoPresupuestarioSubregiones} />
                        <Route exact path={this.props.match.url + '/subregiones/:id/edit'} render={(props) => <PeriodoPresupuestarioSubregionDetalle {...props} action="EDIT" />} />
                        <Route path={this.props.match.url + '/subregiones/:id'} render={(props) => <PeriodoPresupuestarioSubregionDetalle {...props} action="VIEW" />} />
                        <Route exact path={this.props.match.url + '/bases'} component={PeriodoPresupuestarioBases} />
                        <Route exact path={this.props.match.url + '/bases/:id/edit'} render={(props) => <PeriodoPresupuestarioBaseDetalle {...props} action="EDIT" />} />
                        <Route path={this.props.match.url + '/bases/:id'} render={(props) => <PeriodoPresupuestarioBaseDetalle {...props} action="VIEW" />} />
                    </Switch>
                </div>
            </div>
        );
    }
}

export default PeriodoPresupuestario;
